import { render, staticRenderFns } from "./changeHistory.vue?vue&type=template&id=651b7932"
import script from "./changeHistory.vue?vue&type=script&lang=js"
export * from "./changeHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports